import { Breakpoints } from '@mui/material'
import createMixins from '@mui/material/styles/createMixins'
import { BOTTOM_NAVIGATION_HEIGHT, PAGE_PADDING_SIDE, PAGE_PADDING_TOP } from '../util/consts'

// get original configs to be used in following `createMixins`
const createMixin = (breakpoints: Breakpoints) => {
  const mixins = createMixins(breakpoints, {
    cardShadowHover: {
      boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.1)',
    },
    pagePadding: {
      padding: `calc(${PAGE_PADDING_TOP.lg}px + var(--safe-area-statusbarHeight)) ${PAGE_PADDING_SIDE.lg}px`,
      [breakpoints.down('lg')]: {
        padding: `calc(${PAGE_PADDING_TOP.md}px + var(--safe-area-statusbarHeight)) ${PAGE_PADDING_SIDE.md}px`,
      },

      [breakpoints.down('md')]: {
        padding: `calc(${PAGE_PADDING_TOP.sm}px + var(--safe-area-statusbarHeight)) ${PAGE_PADDING_SIDE.sm}px`,
      },

      [breakpoints.down('sm')]: {
        padding: `calc(${PAGE_PADDING_TOP.xs}px + var(--safe-area-statusbarHeight)) ${PAGE_PADDING_SIDE.xs}px`,
      },
    },
    pagePaddingSides: {
      paddingRight: `${PAGE_PADDING_SIDE.lg}px`,
      paddingLeft: `${PAGE_PADDING_SIDE.lg}px`,
      [breakpoints.down('lg')]: {
        paddingRight: `${PAGE_PADDING_SIDE.md}px`,
        paddingLeft: `${PAGE_PADDING_SIDE.md}px`,
      },

      [breakpoints.down('md')]: {
        paddingRight: `${PAGE_PADDING_SIDE.sm}px`,
        paddingLeft: `${PAGE_PADDING_SIDE.sm}px`,
      },

      [breakpoints.down('sm')]: {
        paddingRight: `${PAGE_PADDING_SIDE.xs}px`,
        paddingLeft: `${PAGE_PADDING_SIDE.xs}px`,
      },
    },
    pagePaddingVertical: {
      paddingTop: `calc(${PAGE_PADDING_TOP.lg}px + var(--safe-area-statusbarHeight))`,
      paddingBottom: `calc(${PAGE_PADDING_TOP.lg}px + var(--safe-area-statusbarHeight))`,
      [breakpoints.down('lg')]: {
        paddingTop: `calc(${PAGE_PADDING_TOP.md}px + var(--safe-area-statusbarHeight))`,
        paddingBottom: `calc(${PAGE_PADDING_TOP.md}px + var(--safe-area-statusbarHeight))`,
      },

      [breakpoints.down('md')]: {
        paddingTop: `calc(${PAGE_PADDING_TOP.sm}px + var(--safe-area-statusbarHeight))`,
        paddingBottom: `calc(${PAGE_PADDING_TOP.sm}px + var(--safe-area-statusbarHeight))`,
      },

      [breakpoints.down('sm')]: {
        paddingTop: `calc(${PAGE_PADDING_TOP.xs}px + var(--safe-area-statusbarHeight))`,
        paddingBottom: `calc(${PAGE_PADDING_TOP.xs}px + var(--safe-area-statusbarHeight))`,
      },

      [breakpoints.down('xs')]: {
        paddingBottom: `calc(${BOTTOM_NAVIGATION_HEIGHT}px + 16px)`,
      },
    },
  })

  return mixins
}

export default createMixin
